/* global Resources, Services, Sys */

Services.initServices = function(defaultBettingModes) {
    var initResponse = Resources.readData("gameServerInitResponse"),
        parsedResponse = Resources.readData("gameServerInitResponseObject"),
        currencyISO = Services.moneyManager.getCurrencyIsoName(),
        observable;

    window.Services = Sys.apply(window.Services, {
        activity: new Services.Activity(),
        autoplay: new Services.Autoplay({ initResponse: initResponse, ISO: currencyISO }),
        bet: new Services.Bet({ initResponse: initResponse }),
        clock: new Services.Clock({ parsedResponse: parsedResponse }),
        customMessage: new Services.CustomMessage(),
        dialog: new Services.Dialog(),
        error: new Services.Error(),
        freeRounds: new Services.FreeRounds({ initResponse: initResponse }),
        freeSpins: new Services.FreeSpins(),
        game: new Services.Game({ initResponse: initResponse, parsedResponse: parsedResponse }),
        gameInformation: new Services.GameInformation(),
        gameRound: new Services.GameRound({ initResponse: initResponse }),
        gameRules: new Services.GameRules(),
        gameSettings: new Services.GameSettings({ parsedResponse: parsedResponse }),
        language: new Services.Language(),
        money: new Services.Money({ defaultBettingModes: defaultBettingModes }),
        paytable: new Services.Paytable(),
        pluginMenu: new Services.PluginMenu(),
        ticker: new Services.Ticker(),
        win: new Services.Win({ initResponse: initResponse }),
        response: new Services.Response({ initResponse: initResponse }),
        spin: new Services.Spin({ parsedResponse: parsedResponse })
    });

    observable = new window.Sys.Observable();
    observable.fireEvent("notify:services.init");

    window.Services.game.on(
        "ready",
        function() {
            /**
             * Handles entering game for environments that not use netent loader screen. Originated from GFW-4093.
             * */
            if (Sys.isGcmEnabled) {
                observable.fireEvent("notify:loader.closed");
            }
        }
    );
};
